import {
  AGroupIcon,
  BGroupIcon,
  CGroupIcon,
  DGroupIcon,
  PartyGroupIcon,
} from "../../../components/design-system/icons";

type Pace = "A" | "B" | "C" | "D" | "Party";

const groupIcons: Record<Pace, typeof AGroupIcon> = {
  A: AGroupIcon,
  B: BGroupIcon,
  C: CGroupIcon,
  D: DGroupIcon,
  Party: PartyGroupIcon,
};

export const useGetGroupIcon = ({ group }: { group: Pace }) => {
  return groupIcons[group];
};
